/**
 * Puts the theme's box-line class on Rebuy Smart Cart's drawer lines.
 *
 * The theme's own cart markup (snippets/cart-items.liquid) adds
 * `cart-item--bundle-box` to any line carrying the builder's line property.
 * Rebuy renders the drawer itself, so Liquid cannot reach it — but Rebuy
 * already writes a `property-key-<name>` class onto each line that has a
 * given property. This only renames that class, so one selector works on
 * both the cart page and the drawer.
 *
 * Delete this file and target `.property-key-_melting_wafer_box` directly if
 * you would rather not depend on Rebuy's class names in two places.
 */
(() => {
  const PROPERTY = window.bundleBoxProperty || '_melting_wafer_box';
  const SOURCE = `property-key-${PROPERTY}`;
  const TARGET = 'cart-item--bundle-box';

  const escape = (value) =>
    window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/[^\w-]/g, '\$&');

  const selector = `.${escape(SOURCE)}:not(.${TARGET})`;

  const tag = () => {
    document.querySelectorAll(selector).forEach((line) => {
      line.classList.add(TARGET);
      line.dataset.bundleBox = 'true';
    });
  };

  // Rebuy re-renders the whole line list on every cart change, which drops the
  // added class, so re-apply on mutation rather than once on load.
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      tag();
    });
  };

  const observe = (root) =>
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });

  const start = () => {
    tag();
    const cart = document.querySelector('.rebuy-cart');
    if (cart) {
      observe(cart);
      return true;
    }
    return false;
  };

  if (!start()) {
    // The drawer is injected after the app boots; watch for it, then narrow
    // the observer to the drawer itself so we are not scanning the whole page.
    const waiting = new MutationObserver(() => {
      schedule();
      if (document.querySelector('.rebuy-cart')) {
        waiting.disconnect();
        start();
      }
    });
    waiting.observe(document.body, { childList: true, subtree: true });
  }
})();
